module.exports = __webpack_public_path__ + "static/media/virdee_block_logo.a36f382a.png";